import { UseQueryOptions } from 'react-query';
import { useCustomQuery } from '../../../../hooks/query';
import { ServiceError } from '../../../../hooks/error';
import { GET_FILE_UPLOAED_STATUS, GET_S3_PRE_SIGN_URL } from './keys';
import { RetrieveS3URLResponse, S3FileIOPayLoadItems } from '../api-services/model';
import { getDocumentUploadStatus, getRetrieveS3PreSignURL } from '../api-services/api';

/** to get S3 PreSign URL to Download file
 * @returns any
 * */
export const useGetRetrieveS3PreSignUrl = (
  params: S3FileIOPayLoadItems,
  queryOptions?:
    | UseQueryOptions<RetrieveS3URLResponse, ServiceError, RetrieveS3URLResponse>
    | undefined
) =>
  useCustomQuery<RetrieveS3URLResponse>(
    GET_S3_PRE_SIGN_URL,
    () => getRetrieveS3PreSignURL(params).then((res) => res.data),
    queryOptions,
    false,
    false
  );

/** to get Upload status of a particular file
 * @returns string
 * */
export const useGetDocumentUploadStatus = (fileKey: string, successCallback: () => void) =>
  useCustomQuery<RetrieveS3URLResponse>(
    GET_FILE_UPLOAED_STATUS,
    () => getDocumentUploadStatus(fileKey).then((response) => response.data),
    {
      cacheTime: 0,
      enabled: false,
      onSuccess: successCallback
    }
  );
